import { render, staticRenderFns } from "./RrcvPD.vue?vue&type=template&id=10e54e1f"
import script from "./RrcvPD.vue?vue&type=script&lang=js"
export * from "./RrcvPD.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports